<template>
  <search-group-form-page
    :resource-name="resourceName"
    :url="`projects/${project_id}/searches/`"
    :item_id="null"
    :item="model"
    :title="$t('booleanSearch.new_bool_query')"
    :is-busy="isBusy"
  />
</template>

<script>
// Const
import { query } from "../../config/bool-const";

// Components
import SearchGroupFormPage from "../../components/boolean-search/SearchGroupFormPage.vue";

export default {
  name: "create-query",

  data() {
    return {
      resourceName: 'searches',
      model: { ...query },
    }
  },

  computed: {
    project_id() { return this.$store.state.booleanSearch.project_id },
    isBusy() { return this.$store.state.booleanSearch.isBusy },
  },

  components: {
    SearchGroupFormPage,
  }
}
</script>